import { StaffType } from "../StaffType";

export const StaffTypeLabels = {
  [StaffType.Teacher]: "Teacher",
  [StaffType.SupportStaff]: "Support Staff",
} as const;
